<template>
  <div
    class="md-layout md-alignment-center-center container gray-6 bg new-globals"
  >
    <org-selector @orgChange="onOrgChange" />
  </div>
</template>

<script>
import OrgSelector from '~lib/common/components/OrgSelector';

export default {
  name: 'org-selection',
  components: { OrgSelector },
  methods: {
    onOrgChange() {
      this.$router.push({ name: 'verifyEmail' });
    }
  }
};
</script>

<style>
.container {
  flex-direction: column;
}
</style>
